export default "__VITE_ASSET__14207925__"